import {
  NOTIFICATIONTYPE_ADDED_AS_REVIEWER,
  NOTIFICATIONTYPE_DAILY_STATUS,
  NOTIFICATIONTYPE_HEARING_ANSWER_RECEIPT,
  NOTIFICATIONTYPE_HEARING_CHANGED,
  NOTIFICATIONTYPE_HEARING_CONCLUSION_PUBLISHED,
  NOTIFICATIONTYPE_HEARING_RESPONSE_DECLINE,
  NOTIFICATIONTYPE_INVITED_TO_HEARING,
  NOTIFICATIONTYPE_NEWSLETTER,
  NOTIFICATIONTYPE_NONE,
} from '../constants/api';

export const notificationTypeTextResolver = (translator, notificationType) => {
  switch (notificationType) {
    case NOTIFICATIONTYPE_ADDED_AS_REVIEWER:
      return translator('notificationType.addedAsReviewer');
    case NOTIFICATIONTYPE_INVITED_TO_HEARING:
      return translator('notificationType.invitedToHearing');
    case NOTIFICATIONTYPE_HEARING_ANSWER_RECEIPT:
      return translator('notificationType.hearingAnswerReceipt');
    case NOTIFICATIONTYPE_HEARING_CONCLUSION_PUBLISHED:
      return translator('notificationType.hearingConclusionPublished');
    case NOTIFICATIONTYPE_HEARING_CHANGED:
      return translator('notificationType.hearingChanged');
    case NOTIFICATIONTYPE_HEARING_RESPONSE_DECLINE:
      return translator('notificationType.hearingResponseDecline');
    case NOTIFICATIONTYPE_DAILY_STATUS:
      return translator('notificationType.dailyStatus');
    case NOTIFICATIONTYPE_NEWSLETTER:
      return translator('notificationType.newsletter');
    case NOTIFICATIONTYPE_NONE:
    default:
      return translator('notificationType.none');
  }
};
